var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('footer',{ref:"videoContainer",attrs:{"id":"footer"},on:{"click":_vm.playVoice}},[_c('button',{on:{"click":_vm.playVoice}},[_vm._v("播放通知")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }